import moment from "moment";
import { TimelineCardType } from "../components/CardItem/hooks/useTimelineCardType";
import { MONTHS_LIST } from "../constants";

export const defaultCurrentMonthTimeline2025 = () => {
  // month is start from zero, so January is 0
  const currentMonth = moment()?.month();

  if (currentMonth < 3)
    return {
      index: 3,
      month: moment("2025-04-01")?.locale("en")?.format("MMMM"),
    };

  return {
    index: currentMonth,
    month: moment()?.locale("en")?.format("MMMM"),
  };
};

interface CardTypeProps {
  eventStartDate: string;
  eventEndDate: string;
  registrationStartDate: string;
  registrationEndDate: string;
  videoUrl: string;
  registrationUrl: string;
  isRegistrationOpen: boolean;
}

export const getUpcomingMonth = (currentMonth) => {
  const nextMonth = MONTHS_LIST?.findIndex((data) => data?.value === currentMonth) + 1;

  return nextMonth;
};

export const generateCardType = (data: CardTypeProps): TimelineCardType => {
  const currentDay = moment();

  const { eventStartDate, eventEndDate, registrationStartDate, registrationEndDate, videoUrl } =
    data;

  const withinRegistrationDate = moment(currentDay)?.isBetween(
    registrationStartDate,
    registrationEndDate,
    "day",
    "[]",
  );
  const withinEventDate = moment(currentDay)?.isBetween(eventStartDate, eventEndDate, "day", "[]");
  const isBeforeRegistrationPeriod = moment(currentDay)?.isBefore(registrationStartDate, "day");
  const isAfterRegistrationPeriod = moment(currentDay)?.isAfter(registrationEndDate, "day");
  const isBeforeEventEndDate = moment(currentDay)?.isBefore(eventStartDate, "day");

  /**
   * Upcoming Condition:
   * 1. Before registration period
   * 2. Not within registration date range
   * 3. Not within event date range
   * 4. No video url
   */
  if (isBeforeRegistrationPeriod && !withinRegistrationDate && !withinEventDate) {
    return "upcoming";
  }

  /**
   * Before Event In Registration Period
   * 1. Within registration date range
   * 2. No video URL
   */
  if (withinRegistrationDate) {
    return "before_event_in_registration_period";
  }

  /**
   * Before Event Not In Registration Period
   * 1. After registration period
   * 2. Not within registration date range
   * 3. Not within event date range
   * 4. No Video Url
   * 5. Before event end date
   */
  if (
    isAfterRegistrationPeriod &&
    !withinRegistrationDate &&
    !withinEventDate &&
    isBeforeEventEndDate
  ) {
    return "before_event_not_in_registration_period";
  }

  /**
   * Event Day
   * 1. Within event date range
   * 2. Not within registration date
   * 3. No video url
   * 4.
   */
  if (withinEventDate && !withinRegistrationDate && !videoUrl) {
    return "event_day_without_video_url";
  }

  /**
   * Event Day Final
   * 1. Within event date range
   * 2. Not within registration date
   * 3. Have video url
   */
  if (withinEventDate && !withinRegistrationDate && videoUrl) {
    return "event_day_with_video_url";
  }

  /**
   * pas Event
   * 1. Past event
   * 2. Not within registration date
   * 3. Not within event date range
   */
  return "past_event";
};
